module.exports = __webpack_public_path__ + "media/images/common/icon/icon-arrow-g-054b1768afad377eb6162933766e97c1.svg";